import { useState } from "react";
import {
  getUserLedger,
  getProjectLedger,
} from "../../../Services/billsService";
import { getAllUsers } from "../../../Services/userService";
import { getProjects } from "../../../Services/projectServices";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../Ledgers/constants";

export const useLedger = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const[filters, setFilters] = useState({category: "", type: ""})

  const onPageChange = (newPage) => setPage(newPage);
  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchUserLedger = async (params) => {
    setLoading(true);
    let data = [];
    try {
      const response = await getUserLedger({
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });

      if (response.status === 200) {
        const results = response.data?.results ?? response.data;
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = results;
      } else {
        toast.error(
          extractErrorMessage(response) ||
            TOAST_MESSAGES.USER_LEDGER_FETCH_FAILED
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.USER_LEDGER_FETCH_ERROR
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchUsers = async (params) => {
    let data = [];
    try {
      const res = await getAllUsers({ limit: 10, ...params });
      if (res.status === 200) {
        data = res.data?.results ?? res.data;
      } else {
        toast.error(
          extractErrorMessage(res) || TOAST_MESSAGES.FAIL_USERS_FETCH
        );
      }
    } catch (err) {
      toast.error(extractErrorMessage(err) || TOAST_MESSAGES.ERROR_USERS_FETCH);
    }
    return data;
  };

  const fetchProjectLedger = async (params) => {
    setLoading(true);
    let data = [];
    try {
      const response = await getProjectLedger({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });

      if (response.status === 200) {
        const results = response.data?.results ?? response.data;
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = results;
      } else {
        toast.error(
          extractErrorMessage(response) ||
            TOAST_MESSAGES.USER_LEDGER_FETCH_FAILED
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.USER_LEDGER_FETCH_ERROR
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchAllProjects = async (params) => {
    let data = [];
    try {
      const res = await getProjects({ limit: 10, ...params });
      if (res.status === 200) {
        data = res.data?.results ?? res.data;
      } else {
        toast.error(
          extractErrorMessage(res) || TOAST_MESSAGES.FAIL_USERS_FETCH
        );
      }
    } catch (err) {
      toast.error(extractErrorMessage(err) || TOAST_MESSAGES.ERROR_USERS_FETCH);
    }
    return data;
  };

  return {
    loading,
    page,
    rowsPerPage,
    totalPages,
    onPageChange,
    onPageSizeChange,
    setPage,
    setRowsPerPage,
    setTotalPages,
    fetchUserLedger,
    fetchUsers,
    fetchProjectLedger,
    fetchAllProjects,
  };
};
